var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mian-content"},[_c('div',{staticClass:"page-404"},[_c('span',[_vm._v("抱歉，您访问的页面不存在！")])])])
}]

export { render, staticRenderFns }